<template>
  <div class="container">
    <div class="button-container">
      <div><button :disabled="!eventId" class="{ active: currentContent === 'content_1' }" @click="setContent('content_1')">GPT Output</button></div>
      <div><button :disabled="!eventId" class="{ active: currentContent === 'content_2' }" @click="setContent('content_2')">Data/Stats</button></div>
      <div><button :disabled="!eventId" class="{ active: currentContent === 'content_2' }" @click="setContent('content_11')">Data/Stats 1x2</button></div>
      <div><button :disabled="!eventId" class="{ active: currentContent === 'content_3' }" @click="setContent('content_3')">Full Prompt</button></div>
      <div><button :disabled="!eventId" class="{ active: currentContent === 'content_4' }" @click="setContent('content_4')">Formatted Stats</button></div>
      <div v-if=this.$store.state.useAgents>
        <div><button :disabled="!eventId" :class="{ active: currentContent === 'content_9' }" @click="setContent('content_9')">Agents  Output</button></div>
        <div><button :disabled="!eventId" :class="{ active: currentContent === 'content_5' }" @click="setContent('content_5')">Agents</button></div>
        <div><button :disabled="!eventId" :class="{ active: currentContent === 'content_6' }" @click="setContent('content_6')">Tasks</button></div>
        <div><button :disabled="!eventId" :class="{ active: currentContent === 'content_7' }" @click="setContent('content_7')">Workflow</button></div>
        <div><button :disabled="!eventId" :class="{ active: currentContent === 'content_8' }" @click="setContent('content_8')">Agents Verbose Output</button></div>
      </div>
      <div><button :class="{ active: currentContent === 'content_10' }" @click="setContent('content_10')">List of events</button></div>

    </div>
    <div class="divider"></div>
    <DynamicContent class='content' :content="currentContent" />
  </div>
</template>

<style scoped>

.divider {
  width: 2px;
  background-color: black;
  margin: 0 20px;
}
.container {
  display: flex;
  justify-content: center; /* Center the button container */
  border: 2px solid black;
}
.button-container {
  display: flex;
  flex-direction: column;
  padding: 1em;
  width: 8%;
}

.button-container button {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 30px;
  justify-content: center;
  align-items: center;
    min-width: 120px;
}

.active {
  background-color: darkgrey;  /* Dark grey background for active button */
}

.button button:last-child {
  margin-bottom: 0; /* Removes the bottom margin from the last button */
}
</style>
<script>
import DynamicContent from './DynamicContent.vue';

export default {
  components: {
    DynamicContent
  },
  computed: {
    currentContent() { return this.$store.state.currentContent},
    eventId() {
      return this.$store.state.eventId;
    },
  },
  data() {
    return {
      useAgents: true,
    };
  },
  methods: {
    setContent(newContent) {
      this.$store.commit('setCurrentContent', newContent);
    }
  }
};
</script>